import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import api from '@reserve/api'
import modalHelper from '@appbase/util/modal-helper';
import * as eventTypes from '@reserve/store/event-types'
import * as accountTypes from '@account/store/types'
import { dispatchEventBus } from '@appbase/util';

import { LoadingBar } from '@appbase/components/loading';
import { ViewFrame } from '@appbase/components/editor';
import { mapGetters } from 'vuex';

@Component({
    components: {
        LoadingBar,
        ViewFrame
    },

    computed: mapGetters({
        current: accountTypes.CURRENT
    })
})
export default class ResourceInformation extends Vue {
    @Prop({ type: Object }) value!: reserve.ResourceInformation | undefined;   
    @Prop({ type: String }) uniqueId!: string; 
    
    current!: account.TCurrent;

    mResource: reserve.ResourceInformation | null = null;
    mCategoryName: string = '';
    mBookmarked: boolean = false;
    mNoImage: boolean = true;
    mImageUrl: string = `/cm/gres/faux/images/no_data.png`;   
    
    created() {
        this.mResource = this.value || null;
        var { uniqueId } = this.$route.query;


        if(this.mResource != null) {
            this.mountResourceInfo(this.mResource);
        } else if (uniqueId) {            
            api.resource.getResourceInformation(uniqueId.toString()).then(res => {
                this.mountResourceInfo(res);
            });
        } else if (this.uniqueId) {
            api.resource.getResourceInformation(this.uniqueId).then(res => {
                this.mountResourceInfo(res);
            });
        }
    }

    mountResourceInfo(info: reserve.ResourceInformation) {
        this.mResource = info;        
        this.mCategoryName = this.mResource.itemStore === 'EWS' ?
            this.$t('회의실').toString() :
            this.$t('회사자원').toString();

        this.mBookmarked = info.bookmarked != null;

        if(this.mResource.resourceImage == null) {
            this.mNoImage = true;
            this.mImageUrl = `/cm/gres/faux/images/no_data.png`
        } else {
            this.mNoImage = false;
            this.mImageUrl = `/cm/Portal/Reservation/api/image/${this.mResource.resourceImage}`;
        }
    }    

    toggleBookmark(toggle: boolean) {
        if(this.mResource != null) {
            let uniqueId: string = this.mResource.uniqueId;
            this.mResource = null;

            api.resource.toggleResourceBookmark(toggle, uniqueId).then(async res => {
                if(toggle == res) {
                    dispatchEventBus(
                        this.isTeams ? window : window.opener, 
                        eventTypes.EVENT_RESOURCE_BOOKMARKUPDATED,
                        { uniqueId: toggle });

                    await (window as any).alertAsync(toggle ? '추가되었습니다.' : '삭제되었습니다.');
                }                   
            }).finally(() => {
                api.resource.getResourceInformation(uniqueId).then(res => {
                    this.mountResourceInfo(res);
                });
            });                                                             
        }        
    }
  
    handleClose() {
        if(this.isTeams){
            modalHelper.close();
        }
        else{
            window.close()
        }
    }
}